import { Button, Card, Group, Text } from '@mantine/core'

import { FaIcon } from '#components/FaIcon'
import { OutsideAnchor } from '#components/OutsideAnchor'
import { createMailtoUrl } from '#util'

import { DashboardCardGroup } from './DashboardCardGroup'
import { DashboardCardShell } from './DashboardCardShell'

import styles from './BetaFeedbackCard.module.css'

// TODO: The feedback form is currently disabled.
// Replace FEEDBACK_MAILTO with functionality from
// https://github.com/showrunner/wallaby/pull/4143
const FEEDBACK_MAILTO = createMailtoUrl('support@scripto.live', {
  subject: 'Feedback for Scripto',
})

export const BetaFeedbackCard = () => {
  return (
    <DashboardCardShell>
      <Card className={styles.banner}>
        <DashboardCardGroup align="center" justify="space-between">
          <Group justify="center">
            <FaIcon icon="fa-comment-smile" size="lg" />
            <Text>
              <Text span fw="bold">
                Have feedback on beta features?
              </Text>{' '}
              Let us know!
            </Text>
          </Group>
          <Button
            variant="outline"
            component={OutsideAnchor}
            href={FEEDBACK_MAILTO}
          >
            Give Us Feedback
          </Button>
        </DashboardCardGroup>
      </Card>
    </DashboardCardShell>
  )
}
